import React from 'react'

import Text from '../../../../../components/pdf/Text'
import Grid, { Col } from '../../../../../components/pdf/Grid'
import { useReplies } from '../../_load/ServiceOrderLoader'
import { findReplyByQuestionId, getReplyValue } from '../../_helpers/pdfHelpers'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'

const Contacts = () => {
  const replies = useReplies()

  const clientName = getReplyValue(findReplyByQuestionId(replies, 326))
  const clientAddress = getReplyValue(findReplyByQuestionId(replies, 327))
  const clientEmail = getReplyValue(findReplyByQuestionId(replies, 328))

  const salesRepName = getReplyValue(findReplyByQuestionId(replies, 329))
  const salesRepPhone = getReplyValue(findReplyByQuestionId(replies, 330))
  const salesRepEmail = getReplyValue(findReplyByQuestionId(replies, 331))
  const salesRepFax = getReplyValue(findReplyByQuestionId(replies, 332))

  const primaryContactName = getReplyValue(findReplyByQuestionId(replies, 333))
  const primaryContactPhone = getReplyValue(findReplyByQuestionId(replies, 334))
  const primaryContactEmail = getReplyValue(findReplyByQuestionId(replies, 335))
  const primaryContactFax = getReplyValue(findReplyByQuestionId(replies, 336))

  return (
    <Grid direction="row" gutter={20} align="flex-start">
      <Col flex={1} gutter={20}>
        <Table width="100%" fixedLayout useFontBaseColor>
          <TableRow useFontBaseColor style={{ backgroundColor: '#ffe599' }}>
            <TableCol useFontBaseColor>
              <Text bold>SHIP TO</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text bold>BILL TO</Text>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor>
            <TableCol useFontBaseColor style={{ verticalAlign: 'top' }}>
              <Text>{clientName}</Text>
              <Text>{`${clientAddress?.search}${
                clientAddress?.complement ? ` - ${clientAddress?.complement}` : ''
              }`}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>BR SP TAUA HOTEL E CONVENTION ATIBAIA LTDA </Text>
              <Text>Rodovia Dom Pedro I </Text>
              <Text>Atibaia </Text>
              <Text>SP </Text>
              <Text>12952-729 </Text>
              <Text>BRA</Text>
              <Text>{clientEmail}</Text>
            </TableCol>
          </TableRow>
        </Table>
      </Col>
      <Col flex={1} gutter={20}>
        <Table width="100%" fixedLayout useFontBaseColor>
          <TableRow useFontBaseColor style={{ backgroundColor: '#ffe599' }}>
            <TableCol useFontBaseColor>
              <Text bold align="right">
                SALES REPRESENTATIVE
              </Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text bold align="right">
                PRIMARY CONTACT
              </Text>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor>
            <TableCol useFontBaseColor>
              <Text align="right">{salesRepName}</Text>
              <Text align="right"> Phone: {salesRepPhone}</Text>
              <Text align="right"> Email: {salesRepEmail}</Text>
              <Text align="right"> Fax: {salesRepFax}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text align="right">{primaryContactName}</Text>
              <Text align="right"> Phone: {primaryContactPhone}</Text>
              <Text align="right"> Email: {primaryContactEmail}</Text>
              <Text align="right"> Fax: {primaryContactFax}</Text>
            </TableCol>
          </TableRow>
        </Table>
      </Col>
    </Grid>
  )
}

export default Contacts
